import { AccountMultipleCheckIcon } from './AccountMultipleCheckIcon';

/**
 * author: Roberto Graham
 * id 3B3E2DF7-1E21-476A-8473-7F1EAA514D1F
 * name account-multiple-check
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-check.svg
 * tags
 * - Account / User 
 */
export const PeopleTickIcon = AccountMultipleCheckIcon;
export default PeopleTickIcon